import { render, staticRenderFns } from "./memberPage.vue?vue&type=template&id=f3d98db2&scoped=true&"
import script from "./memberPage.vue?vue&type=script&lang=js&"
export * from "./memberPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3d98db2",
  null
  
)

export default component.exports